import {
  ICanvasElement,
  ICanvasElementDrawArgs,
  IPositionXY
} from '@/models/marketingCenter/canvas';
import { getHTMLImage } from '@/utils/canvas';

class FooterCanvasElement implements ICanvasElement {
  constructor(
    private readonly options: {
      position?: IPositionXY;
    }
  ) {}

  showOnPreview = true;

  async draw(context: CanvasRenderingContext2D, args: ICanvasElementDrawArgs) {
    const footerSVG = require(`../../../assets/img/marketingCenter/canvas/footer.svg`);
    const img = await getHTMLImage(footerSVG);

    const defaultPosition = {
      y: args.canvas.height - img.naturalHeight - 18,
      x: 18
    };

    const { position = defaultPosition } = this.options;

    context.drawImage(img, position.x, position.y);
  }
}

export default FooterCanvasElement;
